import React, {useEffect } from 'react'; 
import LazyLoad from "react-lazyload";
import Header from "../Component/Header";
import { Link } from 'react-router-dom'
const ComputerEducation = () => {
    useEffect(() => {
        document.title = 'Computer Education -  The Air Force School Subroto Park';  
    }, []);  
  return (
     <>
       <Header/>
<div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                <li>  Facilities</li>
                 <li>Computer Education</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1> Computer Education </h1>
                    </div>
                </div>
                <div className="row">
                <div className="col-lg-12">
                    <p>The school has 3 well equipped computer labs with advanced infrastructure in terms of hardware and software to cater to the requirements of the students, teachers and the curriculum. One laboratory is in the junior Wing with 25 computers and two in the senior wing with 25 computers and 36 computers respectively.
                    </p>
                    <p>Education is imparted to all the students from classes UKG - VIII (compulsorily) , for classes IX - XII (optional).
                    </p>
                    <p>One laboratory in Senior Wing is dedicated to students of class XI and XII who have taken Computer Science and Informatics Practices as one of their subjects.</p>
                    </div>
                    <div className="col-lg-3">
                    <LazyLoad>
                    <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/TAFS/public/Images/ComputerEducation.jpg"><img src="https://webapi.entab.info/api/image/TAFS/public/Images/ComputerEducation.jpg" className="schoollib img-fluid" alt="TAFS" /></a> 
                  </LazyLoad>  
                   </div>
                   <div className="col-lg-3">
                   <LazyLoad>
                   <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/TAFS/public/Images/ComputerEducation1.jpg"><img src="https://webapi.entab.info/api/image/TAFS/public/Images/ComputerEducation1.jpg" className="schoollib img-fluid" alt="TAFS" /></a> 
                 </LazyLoad>  
                  </div>
                  <div className="col-lg-3">
                  <LazyLoad>
                  <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/TAFS/public/Images/ComputerEducation2.jpg"><img src="https://webapi.entab.info/api/image/TAFS/public/Images/ComputerEducation2.jpg" className="schoollib img-fluid" alt="TAFS" /></a> 
                </LazyLoad>  
                 </div>
                 <div className="col-lg-3">
                 <LazyLoad>
                 <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/TAFS/public/Images/ComputerEducation3.jpg"><img src="https://webapi.entab.info/api/image/TAFS/public/Images/ComputerEducation3.jpg" className="schoollib img-fluid" alt="TAFS" /></a> 
               </LazyLoad>  
                </div> 
            </div>
            </div>
        </div>
     </>
  )
}

export default ComputerEducation